import React, { useState, useEffect } from 'react';
import { Button } from './Button';
import { Link } from 'react-scroll';
import { Link as LinkRoute} from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const [navbar, setNavbar] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener('resize', showButton);

  const changeBackground = () => {
    if(window.scrollY >= 80) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener('scroll', changeBackground);

  return (
    <>
      <nav className={navbar ? 'navbar active' : 'navbar'}>
        <div className='navbar-container'>
          <LinkRoute to='/' className='navbar-logo' onClick={closeMobileMenu}>
            <h1>Polly Cheng </h1>
          </LinkRoute>
          <div className='menu-icon' onClick={handleClick}>
            <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
          </div>
          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li className='nav-item'>
              <LinkRoute to='/' className='nav-links' onClick={closeMobileMenu}>
                Home
              </LinkRoute>
            </li>
            <li className='nav-item'>
              <Link
                to='characteristic'
                className='nav-links'
                onClick={closeMobileMenu}
                spy={true} smooth={true} offset={-80} duration={100}
              >
                Features
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='about'
                className='nav-links'
                onClick={closeMobileMenu}
                spy={true} smooth={true} offset={-80} duration={100}
              >
                About
              </Link>
            </li>
            <li className='nav-item'>
            <Link
                to='video'
                className='nav-links'
                onClick={closeMobileMenu}
                spy={true} smooth={true} offset={-80} duration={100}
              >
                Video
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='gallery'
                className='nav-links'
                onClick={closeMobileMenu}
                spy={true} smooth={true} offset={-80} duration={100}
              >
                Gallery
              </Link>
            </li>
            <li className='nav-item'>
              <Link
                to='floorplan'
                className='nav-links'
                onClick={closeMobileMenu}
                spy={true} smooth={true} offset={-80} duration={100}
              >
                Floorplan
              </Link>
            </li>
           
          </ul>
          
              <Link
                to='contacts'
                className='nav-links'
                onClick={closeMobileMenu}
                spy={true} smooth={true} offset={-80} duration={100}
              >
                <Button buttonStyle='btn--outline'>Contact Us</Button>
              </Link>
          
          {/* {button && <Button buttonStyle='btn--outline'>Contact Us</Button>} */}
        </div>
      </nav>
    </>
  );
}

export default Navbar;
